module.exports = __webpack_public_path__ + "static/media/bgFooterHelpMobile2.fa345218.jpg";